import { render } from "./PrivacyAndPolicyGlobal.vue?vue&type=template&id=6d3aced7&scoped=true"
import script from "./PrivacyAndPolicyGlobal.vue?vue&type=script&lang=js"
export * from "./PrivacyAndPolicyGlobal.vue?vue&type=script&lang=js"

import "./PrivacyAndPolicyGlobal.vue?vue&type=style&index=0&id=6d3aced7&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d3aced7"]])

export default __exports__